import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { loadScript, loadLink } from '@/helpers';


declare global {
  interface Window {
    ameliaChatOverlayConfig?: any;
    _cmgisPepperEnabled?: string; // added explicit typing for pepper flag
  }
}

@Component({
  name: 'CmgPepperChatLink',
})
export default class CmgPepperChatLink extends Vue {
  private resourcesLoaded:boolean = false;

  mounted() {
    if (!this.isPepperEnabled) {
      return;
    }
    // Use Intersection Observer to detect visibility
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.loadAmeliaResources().then(() => observer.disconnect() // Stop observing after resources are loaded
        );
      }
    });
    observer.observe(this.$el);
  }

  destroyed() {
    const container = document.getElementsByClassName('amelia-chat-overlay-container')[0] as HTMLElement | null;

    if (container) {
      container.style.display = 'none';
      container.parentNode?.removeChild(container);
    }

    const iframe = document.getElementById('amelia-chat-overlay-iframe') as HTMLElement | null;
    if (iframe) {
      iframe.parentNode?.removeChild(iframe);
    }

    const css = document.getElementById('amelia-css') as HTMLElement | null;
    if (css) {
      css.parentNode?.removeChild(css);
    }

    const js = document.getElementById('amelia-js') as HTMLElement | null;
    if (js) {
      js.parentNode?.removeChild(js);
    }
  }

  private async loadAmeliaResources(): Promise<void> {
      if (this.resourcesLoaded) {
      return;
    }

    this.resourcesLoaded = true;

    // Inject Amelia CSS
    if (!document.getElementById('amelia-css')) {
      await loadLink(this.$services.config.getAmeliaPepperCssUrl(), 'amelia-css','stylesheet');
    }

    // Inject Amelia JS
    if (!document.getElementById('amelia-js')) {
      await loadScript(this.$services.config.getAmeliaPepperJsUrl(), 'text/javascript');
    }
  }
  get chatIconUrl(): string {
    return this.$appStore.state.cms.images.icons.chat.default;
  }

  onChatClick(): void {
    this.openChatWindow();
  }

  openChatWindow(): void {
    const iframeId = 'amelia-chat-overlay-iframe';
    if (document.getElementById(iframeId)) {
      const button = document.querySelector('.amelia-chat-overlay-floating-button') as HTMLElement | null;
      if (button) {
        button.click();
      }
      return;
    }
  }

  get isPepperEnabled(): boolean {
    return String((window as any)._cmgisPepperEnabled).toLowerCase() === 'true';
  }
}